import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/utils/config/config.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Injectable({
  providedIn: 'root'
})
export class ReportesService {

	constructor(
		private http: HttpClient,
		private config: ConfigService,
		private sesion: SesionService
	) { }

	controller: string = 'reporte/';

	create(element: any): Observable<any> {
		return this.http.post(this.config.apiUrl + this.controller + `create`, element, this.sesion.headers);
	}

	inventario(desde: string, hasta: string, productos: any[]): Observable<any> {
		return this.http.post(this.config.apiUrl + this.controller + `inventario`, {desde, hasta, productos}, this.sesion.headers);
	}

	ventas(desde: string, hasta: string, productos: any[], encargados: any[], tiposPago: any[], tiposDocumento: any[]): Observable<any> {
		return this.http.post(this.config.apiUrl + this.controller + `venta`, { desde, hasta, productos, encargados, tiposPago, tiposDocumento }, this.sesion.headers);
	}
}
